var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-center align-center",attrs:{"light":"","flat":""}},[(_vm.bild.text)?_c('v-card-text',[_vm._v(" "+_vm._s(_vm.bild.text)+" ")]):_vm._e(),_c('v-img',{attrs:{"src":_vm.bild.bild,"eager":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }